import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { useTranslation } from 'react-i18next';

export function WSSharedTableHeader() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  return (
    <div
      className={`${md(
        ' px-2 justify-between',
        'gap-1 pr-5 justify-start',
      )} border-b border-component-border  w-full min-h-[50px] flex flex-row items-center    mt-2`}
    >
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[80px] pl-2')}  text-start`}>
        {t(i18n_page_settings_workspace.tabs.shared_entities.table_base.column.actions)}
      </span>
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[215px]')} text-left `}>
        {t(i18n_page_settings_workspace.tabs.shared_entities.table_base.column.name)}
      </span>
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[215px]')}  text-left`}>
        {t(i18n_page_settings_workspace.tabs.shared_entities.table_base.column.started_at)}
      </span>
      <span className={`${md('w-[45px] text-[9px]', 'min-w-[120px]')}  text-left`}>
        {t(i18n_page_settings_workspace.tabs.shared_entities.table_base.column.shared_by)}
      </span>
    </div>
  );
}
